import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import type { OrganizationUser } from '@/types/organization';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

export const getUsers = async (scope: RequestScope, options: ReadRequestOptions): Promise<EndpointResponse<OrganizationUser[]>> => {
  try {
    const response = await scopedApi(scope).get<EndpointResponse<OrganizationUser[]>>('/organization/user', options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
